<template>
    <div class="page-layout blank contacts-manage">
        <div class="pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span>Reminders</span>
                            <div>List View</div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center my-2">
                        <button v-if="reminderType == 'My Reminders' && userPermissions.reminders.permitted_actions.create" class="btn btn-new-green btn-wide px-6" @click="createReminder()">+ Create Reminder</button>
                        <el-dropdown trigger="click" class="type-select ml-4" >
                            <span class="el-dropdown-link d-flex justify-content-between w-100 px-3">
                                {{reminderType == 'Invitations' ? 'Other Reminders' : 'My Reminders'}} <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey-full.svg" style="margin-right: 4px;margin-left: 18px;">
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="changeReminderType('My Reminders')">My Reminders</el-dropdown-item>
                                <el-dropdown-item @click.native="changeReminderType('Invitations')">Other Reminders</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="d-flex pl-2 dis-none-ms ml-2 mb-2" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -10px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_reminders !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" v-model="search_reminders" v-debounce:500ms="searchReminders" debounce-events="input" class="w-100 placeholder-text" type="text"
                            :placeholder="reminderType == 'My Reminders' ? 'Search by Reminder Name, Reminder Type and Assigned person' : 'Search by Reminder Name, Reminder Type and Other Reminder sender'"
                            style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </h2>
        </div>
        <!-- v-if="(all_list_count != 0 && !show_filtered_date.length)" -->
        <div class="pb-0 px-3">
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'list_view','new-blue':active_tab == 'list_view'}" @click="switchTabs('list_view')">
                        <span class="text-capitalize">List View</span>
                    </div>
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'pending','new-blue':active_tab == 'pending'}" @click="switchTabs('pending')">
                        <span class="text-capitalize">Pending</span>
                    </div>
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'complete','new-blue':active_tab == 'complete'}" @click="switchTabs('complete')">
                        <span class="text-capitalize">Complete</span>
                    </div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li :class="{'tab-current':active_tab == 'list_view'}">
                                <a href="javascript:;" @click="switchTabs('list_view')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <li :class="{'tab-current':active_tab == 'pending'}">
                                <a href="javascript:;" @click="switchTabs('pending')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Pending</span>
                                </a>
                            </li>
                            <li :class="{'tab-current':active_tab == 'complete'}">
                                <a href="javascript:;" @click="switchTabs('complete')" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span style="border-radius: 30px 0 0 0;">Complete</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex pl-2 dis-none" style="flex-grow: 1">
                    <div class="d-flex" style="flex-grow: 1;position: relative;margin-left: -10px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_reminders !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" v-model="search_reminders" v-debounce:500ms="searchReminders" debounce-events="input" class="w-100 placeholder-text" type="text"
                            :placeholder="reminderType == 'My Reminders' ? 'Search by Reminder Name, Reminder Type and Assigned person' : 'Search by Reminder Name, Reminder Type and Other Reminder sender'"
                            style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-10 mx-3" style="background: #fff; border-top-right-radius: 5px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px">
            <div v-if="ajaxCallInProgress" class="pt-5">
                <div class="main-div pb-0">
                    <div class="create-company-header d-flex align-items-center justify-content-between">
                        <span class="fs-14 ml-3 text-white fw-500">My Reminders</span>
                        <span class="float-right pr-1">
                            <span v-if="dateRange.length" @click="closeDate()" class="date-cancel-btn">&#10005;</span>
                            <date-picker v-model="dateRange" format="DD/MM/YYYY hh:mm A"
                                    range class="date-width white-datepicker reminder callreport-listdate date-card-display calendar-height-top" :show-second="false"
                                lang="en" @change="FormatDT" :clearable="true" confirm confirm-text="APPLY" type="date">
                            </date-picker>
                        </span>
                    </div>
                </div>
                <!-- :not-after="new Date()" -->
                <div class="d-flex align-items-center justify-content-center w-100" style="height: 500px">
                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
            </div>
            <!-- <div v-else-if="(all_list_count == 0 && !ajaxCallInProgress && !show_filtered_date.length)">
                <div  class="table-block overflow-x-auto" style="background-color:#fff;border-top-right-radius:5px">
                    <table class="team-list-table w-100">
                        <thead>
                            <tr>
                                <th v-if="(reminderType == 'My Reminders' && !ajaxCallInProgress)">My Reminders</th>
                                <th v-if="(reminderType == 'Invitations' && !ajaxCallInProgress)">Other Reminders</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100 mb-10" style="background: #fff;height:300px">
                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
                <div v-else class="text-center">
                    <div style="background-color: #e8efff;border: 20px solid #fff; height: 410px; padding-top: 50px;">
                        <img src="/static/images/employee-discussing-strategy-in-the-office.svg" alt="" height="150px" width="150px">
                        <h5 v-if="reminderType == 'My Reminders'">Create a Reminder</h5>
                        <h6 v-if="reminderType == 'Invitations'">No Other Reminders added!</h6>
                        <p v-if="reminderType == 'My Reminders'" >Set a Reminder so you don’t forget to do it.</p>
                        <button v-if="reminderType == 'My Reminders'" class="btn btn-new-green btn-wide px-6 mb-5 mt-3" @click="createReminder()">+ Create a Reminder</button>
                    </div>
                </div>
            </div> -->
            <div v-else-if="!ajaxCallInProgress && reminders_list.length == 0" class="pt-5">
                <div class="main-div pb-0">
                    <div class="create-company-header d-flex align-items-center justify-content-between">
                        <span class="fs-14 ml-3 text-white fw-500" v-if="(reminderType == 'My Reminders' && !ajaxCallInProgress)">My Reminders</span>
                        <span class="fs-14 ml-3 text-white fw-500" v-if="(reminderType == 'Invitations' && !ajaxCallInProgress)">Other Reminders</span>
                        <span class="float-right pr-1">
                            <span v-if="dateRange.length" @click="closeDate()" class="date-cancel-btn">&#10005;</span>
                            <date-picker v-model="dateRange" format="DD/MM/YYYY hh:mm A"
                                    range class="date-width white-datepicker reminder callreport-listdate date-card-display calendar-height-top" :show-second="false"
                                lang="en" @change="FormatDT" :clearable="true" confirm confirm-text="APPLY" type="date">
                            </date-picker>
                        </span>
                    </div>
                </div>
                <div class="px-10 mt-5" v-if="dateRange.length">
                    <p class="fs-14 text-secondary">Shows reminders : {{show_filtered_date}}</p>
                </div>
                <div  style="height: 500px">
                <div class="d-flex justify-content-center align-items-center w-100 pt-30" >
                    <img src="/static/images/contact-list.png" class="" style="width: 30%!important; height: 30%!important;"/>
                    </div>
                <div class="d-flex justify-content-center align-items-center w-100 pt-4" >
                    <h6 v-if="reminderType == 'My Reminders'">No Reminders added!</h6>
                    <h6 v-if="reminderType == 'Invitations'">No Other Reminders added!</h6>
                </div>
            </div>
            </div>
            <div v-else style="overflow-x: hidden; min-height: 700px;" class="py-5">
                <div class="main-div pb-0">
                    <div class="create-company-header d-flex align-items-center justify-content-between">
                        <span v-if="(reminderType == 'My Reminders' && !ajaxCallInProgress)" class="fs-14 ml-3 text-white fw-500">My Reminders</span>
                        <span v-if="(reminderType == 'Invitations' && !ajaxCallInProgress)" class="fs-14 ml-3 text-white fw-500">Other Reminders</span>
                        <span class="float-right pr-1">
                            <span v-if="dateRange.length" @click="closeDate()" class="date-cancel-btn">&#10005;</span>
                            <date-picker v-model="dateRange" format="DD/MM/YYYY hh:mm A" type="datetime" :time-picker-options="timePickerOptions"
                                    range class="date-width white-datepicker reminder callreport-listdate date-card-display calendar-height-top" :show-second="false"
                                lang="en" @change="FormatDT" :clearable="true" confirm confirm-text="APPLY">
                            </date-picker>
                        </span>
                    </div>
                </div>
                <div class="px-10 mt-5" v-if="dateRange.length">
                    <p class="fs-14 text-secondary">Shows reminders : {{show_filtered_date}}</p>
                </div>
                <div class="row px-5">
                    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 mt-3 px-1" v-for="(reminder,rem_index) in reminders_list" :key="rem_index">
                        <div class="mt-2 mx-2 bordrad-5px position-relative" style="box-shadow: 0 4px 8px 0 #cdd2da;">
                            <div class="d-flex">
                                <div class="w-25 p-3" style="border-right:1px solid #cdd2da">
                                    <div class="calendar-custom text-center position-relative">
                                        <div class="calendar-holder" style="left: 15%"></div>
                                        <div class="calendar-holder" style="right: 15%"></div>
                                        <div class="text-white" style="border-bottom:3px solid #abc1e5;">{{reminder.month}}</div>
                                        <div class="text-white fs-15 fw-600">{{reminder.day}}</div>
                                    </div>
                                    <div class="mt-3 text-center">
                                        <div class="text-secondary fs-12 overflowing-text fw-500" :title="reminder.weekday">{{reminder.weekday}}</div>
                                        <div class="text-secondary fs-12">{{reminder.remind_time}}</div>
                                    </div>
                                </div>
                                <div class="w-75 p-3">
                                    <div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fw-600 fs-15 overflowing-text text-capitalize text-nowrap" :title="reminder.reminder_title">{{reminder.reminder_title}}</div>
                                            <div class="d-flex">
                                                <i class="icon icon-eye fs-20 text-dark-blue w-1re pointer" @click="viewReminder(reminder.id, reminder.recurring_id)"></i>
                                                <i class="icon icon-pencil fs-20 pointer text-dark-blue ml-2 w-1re" v-if="(reminder.is_edit && userPermissions.reminders.permitted_actions.edit && reminder.origin != 'call_report')" @click="editReminder(reminder.id, reminder.recurring_id)"></i>
                                                <i class="icon icon-trash fs-20 pointer text-dark-blue ml-2 w-1re" v-if="userPermissions.reminders.permitted_actions.delete && reminder.is_delete && reminder.origin != 'call_report'" @click="DeleteSelectedReminder(reminder.id, reminder.recurring_id)"></i>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="fs-14 overflowing-text sub-txt fw-500 mt-1 text-capitalize">{{reminder.reminder_type.replaceAll("_", " ")}}</div>
                                            <div v-if="reminder.repeat_details.repeat_cycle_type == 'annually'" class="fs-14 overflowing-text sub-txt fw-500 mt-1 text-capitalize"> Year : {{reminder.year}}</div>
                                        </div>
                                        <div v-if="(reminderType == 'My Reminders' || reminderType == 'Invitations' && (reminder.type == 'follow_up' || reminder.type == 'task'))" class="d-flex">    
                                            <div class="fs-12 overflowing-text sub-txt fw-500 mt-1 text-capitalize d-flex">Assigned to : <div class="text-truncate" style="max-width: 100px !important;padding-left: 4px;" :title="reminder.invitees[0].full_name"> {{ reminder.invitees.length == 0 ? '-' : reminder.invitees[0].full_name }}</div></div>
                                            <div v-if="reminder.invitees.length > 1">
                                                <el-popover
                                                    placement="bottom"
                                                    width="auto"
                                                    trigger="hover">
                                                    <span v-for="(assgned_to, assgned_to_index) in reminder.invitees" :key="assgned_to_index">
                                                        <span v-if="assgned_to_index > 0" class="fw-500 custom_chips">{{assgned_to.full_name}}</span>
                                                    </span>
                                                    <el-button slot="reference" style="background-color: transparent;font-weight: 500 !important;font-size: 14px !important;padding: 5px 8px !important;" >
                                                        <div class="fw-500 mt-4px text-center text-secondary">
                                                            +{{reminder.invitees.length - 1}} more
                                                        </div>
                                                    </el-button>
                                                </el-popover><br>
                                            </div>
                                        </div>
                                        <div class="fs-12 overflowing-text sub-txt fw-500 mt-1 text-capitalize" v-else>Invited by : {{reminder.created_by_name || "-"}}</div>
                                        <div class="d-flex justify-content-between mt-1">
                                            <div class="fs-12 overflowing-text sub-txt fw-500">
                                                <span>Remind Before :</span>
                                                <span class="ml-2 remind-time">
                                                    {{reminder.remind_cycle_period}}
                                                    <span v-if="reminder.remind_period < 2">
                                                        {{reminder.remind_cycle_type == 'minute' ? 'Min' : reminder.remind_cycle_type == 'hour' ? 'Hr' : reminder.remind_cycle_type == 'day' ? 'Day' : ''}}
                                                    </span>
                                                    <span v-else>
                                                        {{reminder.remind_cycle_type == 'minute' ? 'Mins' : reminder.remind_cycle_type == 'hour' ? 'Hrs' : reminder.remind_cycle_type == 'day' ? 'Days' : ''}}
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="fs-12 overflowing-text sub-txt fw-500 text-capitalize" :class="reminder.status == 'pending' ? 'text-warning' : 'completed' ? 'text-success' : ''">{{reminder.status}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Pagination Section -->
            <div v-if="reminders_list.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4" style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                <button @click="firstPage()" class="mt-1 pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" class="pagination-list mt-1 ml-2" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" class="pagination-list mt-1 mr-2" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <delete-event @hideDeleteEvent="hideDeleteEvent" :selected_id="selected_id" v-if="delete_event" modal_name="deleteEvent" @deleteReminder="deleteReminder"></delete-event>
        <create-reminder :reminderType="reminderType" v-if="createReminderShow" :mode_id="mode_id" :recurring_id="recurring_id" :view_mode="view_mode" modal_name="createReminder" @hideCreateReminder="hideCreateReminder" @hideCreateReminderSave="hideCreateReminderSave"></create-reminder>
    </div>
</template>
<script>
import moment from 'moment';
import convert from '../mixins/convert'
import { HalfCircleSpinner } from "epic-spinners";
import {EventBus} from "../eventBus/nav-bar-event.js";
const CreateReminder = () => import("./CreateReminder.vue");
const DeleteEvent = () => import('../alertModals/DeleteReminderEvent')
import reminders from "../mixins/reminders"
import { SweetModal } from 'sweet-modal-vue';
export default ({
    mixins: [convert, reminders],
    data(){
        return {
            success_msg: '',
            warning_msg: '',
            search_key: "",
            temp_total: 0,
            skip: 0,
            limit: 12,
            skip_temp: 0,
            total: 0,
            createReminderShow: false,
            reminderType: "My Reminders",
            reminders_list: [],
            active_tab: 'list_view',
            pending: false,
            list_view: false,
            pending: false,
            search_reminders: '',
            dateRange: [],
            delete_event: false,
            view_mode: 'create',
            mode_id: '',
            recurring_id: '',
            show_filtered_date:'',
            selected_id: '',
            ajaxCallInProgress: false,
            timePickerOptions:{
                start: '00:00',
                step: '00:30',
                end: '23:30'
            },
            temp_start_date: '',
            temp_end_date: '',
            temp_start_time: '',
            temp_end_time: '',
            all_list_count: 0,
            delete_type: '',
        }
    },
    components: {
        CreateReminder,
        DeleteEvent,
        HalfCircleSpinner,
        SweetModal,
    },
    methods: {
        //It clears search input field
        clearSearch(){
            this.search_reminders = "";
            this.search_key = "";
            if(this.active_tab == 'list_view') {
                this.$refs.searchInput.focus();
                this.switchTabs('list_view');
            }
            else if(this.active_tab == 'pending') {
                this.$refs.searchInput.focus();
                this.switchTabs('pending');
            }
            else if(this.active_tab == 'complete') {
                this.$refs.searchInput.focus();
                this.switchTabs('complete');
            }
        },
        //It clears search input field
        clearSearch(){
            this.search_reminders = ""
            this.search_key = ""
            this.$refs.searchInput.focus();
            this.loadReminders();
        },
        closeDate(){
            this.dateRange = []
            this.show_filtered_date = ""
            this.temp_start_date = ''
            this.temp_end_date = ''
            this.temp_start_time = ''
            this.temp_end_time = ''
            this.loadReminders();
        },
        //Converts time format
        convertTime12to24(time12h){
            const [time, modifier] = time12h.split(' ');
            let [hours, minutes] = time.split(':');
            if (hours === '12') {
                hours = '00';
            }
            if (modifier === 'PM') {
                hours = parseInt(hours, 10) + 12;
            }
            return `${hours}:${minutes}`;
        },
        FormatDT(){
            this.show_filtered_date = ""
            this.dateRange.forEach((el, el_index) => {
                if(el_index == 1){
                    this.show_filtered_date += this.formatDateTime(el)
                    this.temp_end_date = moment(el).format("YYYY-MM-DD")
                    this.temp_end_time = moment(el).format("hh:mm A")
                } else {
                    this.show_filtered_date += this.formatDateTime(el) + ' - '
                    this.temp_start_date = moment(el).format("YYYY-MM-DD")
                    this.temp_start_time = moment(el).format("hh:mm A")
                }
            })
            this.temp_start_time = this.convertTime12to24(this.temp_start_time)
            this.temp_end_time = this.convertTime12to24(this.temp_end_time)
            this.loadReminders();
        },
        changeReminderType(type){
            if(type != this.reminderType){
                this.temp_total = 0
                this.skip = 0
                this.skip_temp = 0
                this.search_reminders = ''
                this.search_key = ''
                this.reminderType = type
                this.loadReminders();
            }
        },
        disableDateRange(){
            const today = new Date();
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            return date < today && date >today.setTime(today.getTime() - dateOffset)
        },
        createReminder(){
            this.mode_id = ''
            this.recurring_id = ''
            this.view_mode = 'create'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        hideCreateReminderSave(){
            this.createReminderShow = false;
            this.mode_id = ''
            this.recurring_id = ''
            this.view_mode = 'create'
            this.loadReminders();
        },
        hideCreateReminder(){
            this.createReminderShow = false;
            // if(recall_api){
            //     this.loadReminders();
            // }
        },
        //Changes tab
        switchTabs(type){
            this.temp_total = 0
            this.skip = 0
            this.skip_temp = 0
            this.search_reminders = ''
            this.search_key = ''
            if(type == 'list_view'){
                this.active_tab = 'list_view'
                this.list_view = true
                this.pending = false
                this.complete = false
                this.loadReminders();
            } else if(type == 'pending') {
                this.active_tab = 'pending'
                this.list_view = false
                this.pending = true
                this.complete = false
                this.loadReminders();
            } else if(type == 'complete'){
                this.active_tab = 'complete'
                this.list_view = false
                this.pending = false
                this.complete = true
                this.loadReminders();
            }
        },
        DeleteSelectedReminder(id, rec_id){
            this.selected_id = id;
            this.recurring_id = rec_id
            this.delete_event = true
            setTimeout(() => {
                this.$modal.show('deleteEvent')
            }, 500);
        },
        hideDeleteEvent(){
            this.delete_event = false
            this.selected_id = ''
        },
        //API call to delete selected reminder
        async deleteReminder($event) {
            try{
                this.ajaxCallInProgress = true
                this.reminders_list.length = 0
            let response = await this.DeleteToolReminderById(this.selected_id, this.recurring_id, $event);
                if (response.status_id == 1) {
                    this.hideDeleteEvent();
                    this.selected_id = "";
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.loadReminders();
                    }, 1000);
                    this.ajaxCallInProgress = false
                }else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 1000);
                    this.ajaxCallInProgress = false
                }
            }catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.ajaxCallInProgress = false
                }, 1000);
            }

        },
        viewReminder(id, rec_id){
            this.mode_id = id
            this.recurring_id = rec_id
            this.view_mode = 'view'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        editReminder(id, rec_id){
            this.mode_id = id
            this.recurring_id = rec_id
            this.view_mode = 'edit'
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        },
        //API call to search reminder
        async searchReminders(key){
            this.ajaxCallInProgress = true
            let category = ''
            let status = ''
            if(this.active_tab == "pending"){
                status = "pending"
            } else if(this.active_tab == "complete"){
                status = "completed"
            }
            if(this.reminderType == "My Reminders"){
                category = "created"
            }else{
                category = "invitation"
            }
            this.search_key = key
            let params = {
                product_name: "CRM",
                limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                skip: this.skip,
                search_key: this.search_key,
                category: category,
                filter_json: {
                    "status": status,
                    "created_time": this.show_filtered_date
                }
            }
            let response = await this.getToolRemindersList(params)
            this.reminders_list = response.response
            this.total = response.total_count
            this.ajaxCallInProgress = false
        },
        //Pagination methods
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            this.skip_temp = 0
            this.loadReminders()
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.loadReminders()
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.loadReminders()
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.loadReminders()
        },
        //API call to reminder data based on id
        async loadReminders(){
            this.ajaxCallInProgress = true
            let category = ''
            let status = ''
            if(this.active_tab == "pending"){
                status = "pending"
            } else if(this.active_tab == "complete"){
                status = "completed"
            }
            if(this.reminderType == "My Reminders"){
                category = "created"
            }else{
                category = "invitation"
            }
            try{
                let params = {
                    product_name: "CRM",
                    skip: this.skip,
                    limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                    search_key: this.search_key,
                    category: category,
                    filter_json:{
                        status: status,
                        date_time:{
                            from_date: this.temp_start_date,
                            from_time: this.temp_start_time,
                            to_date: this.temp_end_date,
                            to_time: this.temp_end_time
                        }
                    }
                }
                let response = await this.getToolRemindersList(params)
                this.reminders_list = response.response
                if(this.active_tab == 'list_view'){
                    this.all_list_count = this.reminders_list.length
                }
                this.total = response.total_count
                this.ajaxCallInProgress = false
            }catch(error){

            }
        },
    },
    mounted(){
        this.loadReminders();
        EventBus.$on("reminders", () => {
            this.createReminderShow = true;
            setTimeout(() => {
                this.$modal.show("createReminder")
            }, 500);
        })
    },
    computed:{
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
    },
    created(){
        this.createReminderShow = this.$route.params.reminders
        setTimeout(() => {
            this.$modal.show("createReminder")
        }, 500);
    }
})
</script>
<style scoped>
    .w-150px{
        width: 150px !important;
    }

    .type-select{
        background: #fff;
        border-radius: 30px;
        height: 2.7em;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        color: #000;
        width: auto;
    }
    .team-list-table thead tr th {
        background: #005dae;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .overflow-reminders {
        overflow-x: hidden;
        height: 500px;
    }
    .slant-tabs{
        height: 43px;
    }
    .calendar-custom{
        height:50px;
        width:50px;
        background-color: #0d5be6;
        border:3px solid #abc1e5;
        border-radius:6px;
        margin:auto
    }
    .calendar-holder{
        width: 4px;
        height: 11px;
        background-color: rgb(171, 193, 229);
        position: absolute;
        top: -9px;
        border-radius: 10px;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .text-dark-blue {
          color: #00448b;
    }
    .overflowing-text{
          overflow: hidden;
          text-overflow: ellipsis;
     }
     .w-25{
        width: 25% !important;
     }
     .w-75{
        width: 75% !important;
     }
     .sub-txt{
        font-weight: 500;
        line-height: 1.82;
        text-align: left;
        color: #707070;
     }
     .remind-time{
        background: #128807;
        color: #fff;
        padding: 8px;
        border-radius: 100%;
        white-space: nowrap;
     }
     .bordrad-5px {
          border-radius: 5px !important;
     }
     .w-1re{
        width: 1.5rem !important;
     }
    .date-cancel-btn{
        color: #fff;
        cursor: pointer;
        position: absolute;
        right: 65px;
        padding-top: 6px;
        font-weight: 600;
        z-index: 9999;
        font-size: 16px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    .custom_chips{
        display: inline-flex;
        padding: 3px 12px;
        background: #dfe8f4;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 12.5px;
        cursor: pointer;
        color: #4e5764;
    }
    @media only screen and (max-width: 580px) {
        .dis-none{
            display: none !important;
        }
    }
    @media only screen and (min-width: 581px) {
        .dis-none-ms{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Reminders/RemindersListView.vue